import { createAction, props } from '@ngrx/store';

const GET_SERVICES = '[Services] Get Services';
const GET_SERVICES_BY_APPID = '[Services] Get Services by App Id';
const SET_SERVICES_BY_APPID = '[Services] Set Services by App Id';
const SERVICES_SEARCH = '[Services] Search Services';
const SAVE_SERVICES = '[Services] Save Services';
const UPDATE_SERVICES_ORDER = '[Services] Update Services';
const DELETE_SERVICES = '[Services] Delete Services';
const SET_SERVICES = '[Services] Set Services';
const GET_SERVICES_ORDER = '[Services] Get ServicesOrder';
const SET_SERVICES_ORDER = '[Services] Set ServicesOrder';
const GET_FIELDS = '[Services] Get Table Fields';
const GET_PARENT_FIELDS = '[Services] Get Parent Table Fields';
const SET_PARENT_FIELDS = '[Services] Set Parent Table Fields';
const GET_FIELDS_FOR_TABLE = '[Services] Get Fields for Table';
const SET_FIELDS = '[Services] Set Table Fields';
const SET_FIELDS_FOR_TABLE = '[Services] Set Fields for Table';

const getServices = createAction(GET_SERVICES, props<{ apiConstants: any; filter: any }>());
const getServicesByAppId = createAction(GET_SERVICES_BY_APPID, props<{ apiConstants: any }>());

const setServicesByAppId = createAction(SET_SERVICES_BY_APPID, props<{ servicesByAppId: any }>());
const getServicesBasedOnSearch = createAction(SERVICES_SEARCH, props<{ searchApiConstants: any; searchFields: any }>());
const setServices = createAction(SET_SERVICES, props<{ servicesTable: any }>());

const setTotRecs = createAction(SET_SERVICES, props<{ totalServRecords: any }>());

const saveServices = createAction(SAVE_SERVICES, props<{ saveapiConstants: any; servicesData: any }>());

const deleteServices = createAction(DELETE_SERVICES, props<{ deleteserviceApiConstants: any; serviceIds: any }>());

const getServicesOrder = createAction(GET_SERVICES_ORDER, props<{ apiConstants: any }>());

const setServicesOrder = createAction(SET_SERVICES_ORDER, props<{ servicesOrder: any }>());

const updateServicesOrder = createAction(
  UPDATE_SERVICES_ORDER,
  props<{ saveAPiConstants: any; servicesOrderData: any }>()
);

const getFields = createAction(GET_FIELDS, props<{ serviceAPiConstants: any; params: any }>());
const getParentFields = createAction(GET_PARENT_FIELDS, props<{ parentAPiConstants: any; params: any }>());
const setParentFields = createAction(SET_PARENT_FIELDS, props<{ parentFields: any }>());

const setFields = createAction(SET_FIELDS, props<{ fields: any }>());

const getFieldsForTable = createAction(GET_FIELDS_FOR_TABLE, props<{ fstAPiConstants: any; params: any }>());

const setFieldsForTable = createAction(SET_FIELDS_FOR_TABLE, props<{ tblFields: any }>());
export {
  getServices,
  saveServices,
  updateServicesOrder,
  deleteServices,
  setServices,
  getServicesOrder,
  getServicesBasedOnSearch,
  setServicesOrder,
  getFields,
  setFields,
  getFieldsForTable,
  setFieldsForTable,
  setTotRecs,
  getParentFields,
  setParentFields,
  getServicesByAppId,
  setServicesByAppId
};
